// Constants
import * as Constants from "../../constants";

// Helpers
import DB from "../../helpers/db";

import entityObj from "../json/entityPortal.json";
import entityView from "../json/entityView.json";
import ballotView from "../json/ballotView.json";
import groupView from "../json/groupView.json";
import envObj from "../json/env.json";
import dummyData from "../json/dummy.json";

import { APPCONFIG } from "../definitions";

export const fetchAppConfig = () => async (dispatch) => {
  try {
    dispatch({
      type: APPCONFIG.START_FETCH,
    });
    const response = dummyData;
    let configJsonObj = {
      data: {},
      statusCode: "0",
    };
    let dataObj = {
      APPLICATIONS: [],
      ENVIRONMENT: [],
    };
    let applicationsObj = {
      name: "EntityMemberPortal",
      _uid: "entityMemberPortal",
      PAGES: [],
    };

    let pagesObj = [];
    pagesObj.push(entityView);
    pagesObj.push(entityObj);
    pagesObj.push(ballotView);
    pagesObj.push(groupView);

    applicationsObj["PAGES"] = pagesObj;
    dataObj["APPLICATIONS"].push(applicationsObj);
    dataObj["ENVIRONMENT"].push(envObj);
    configJsonObj.data = dataObj;
    response.data = JSON.parse(JSON.stringify(configJsonObj));
    dispatch({
      type: APPCONFIG.FINISH_FETCH,
      payload: response.data.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: APPCONFIG.FAIL_FETCH,
      payload: error,
    });
  }
};
